/*
 * EAUDE17 Cart Drawer (Phase 1)
 *
 * - Mengen ändern, Entfernen, Empfehlungen per „+“ hinzufügen, Rabattcodes – alles per Shopify
 *   AJAX Cart API, ohne Seitenreload. Danach wird der komplette Drawer-Inhalt neu von Shopify
 *   gerendert (templates/cart.ajax.liquid), damit Preise, Staffelrabatte, Summen, 80-€-Fortschritt
 *   und Upsell immer exakt dem Shopify-Stand entsprechen. Hier wird kein Preis berechnet.
 * - Eigene data-e17-* Attribute, damit die globalen Theme-Handler ([data-update-quantity],
 *   .quantity-input, [data-ajax-cart-delete]) nicht zusätzlich auslösen.
 * - Die bestehende Theme-Schnittstelle window.PXUTheme.jsAjaxCart bleibt erhalten (addToCart,
 *   showDrawer, hideDrawer). Nur updateView wird auf E17Cart.refresh umgeleitet.
 */
(function () {
  // Das Theme bindet die Drawer-Hülle (und damit z__jsAjaxCart.js) zweimal ein – Desktop- und
  // Mobile-Header. Jeder Durchlauf erzeugt window.PXUTheme.jsAjaxCart neu, daher hier bei jedem
  // Laden erneut verknüpfen, die Logik selbst aber nur einmal registrieren.
  if (window.E17Cart) {
    window.E17Cart.hook();
    return;
  }

  var CONTENT = '[data-ajax-cart-content]';
  var busy = false;
  var flash = null;

  function cartUrl() {
    return (window.PXUTheme && window.PXUTheme.routes && window.PXUTheme.routes.cart_url) || '/cart';
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) {
          var err = new Error(data.description || data.message || 'Fehler');
          err.data = data;
          throw err;
        }
        return data;
      });
    });
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) {
      return r.json();
    });
  }

  function setBusy(state) {
    busy = state;
    document.querySelectorAll('[data-e17-cart]').forEach(function (el) {
      el.classList.toggle('is-busy', state);
      el.setAttribute('aria-busy', state ? 'true' : 'false');
    });
  }

  function showFlash(text, type) {
    flash = { text: text, type: type || 'info' };
    renderFlash();
  }

  function renderFlash() {
    if (!flash) return;
    document.querySelectorAll('[data-e17-code-msg]').forEach(function (el) {
      el.textContent = flash.text;
      el.className = 'e17-code__msg is-' + flash.type;
    });
  }

  /** Pfeil „weitere Empfehlungen“ nur zeigen, wenn die Kartenreihe breiter als sichtbar ist (rein optisch). */
  function updateArrows() {
    document.querySelectorAll('[data-e17-row]').forEach(function (row) {
      var btn = row.parentNode.querySelector('[data-e17-scroll-next]');
      if (!btn) return;
      var more = row.scrollWidth - row.clientWidth - row.scrollLeft > 8;
      btn.hidden = !more;
    });
  }

  /** Der sichtbare Drawer-Inhalt (das Theme rendert die Hülle zweimal: Desktop- und Mobile-Header). */
  function visibleCart() {
    var all = document.querySelectorAll(CONTENT + ' .e17-cart');
    for (var i = 0; i < all.length; i++) {
      if (all[i].getClientRects().length) return all[i];
    }
    return null;
  }

  /** Drawer-Inhalt komplett neu von Shopify laden und einsetzen. */
  function refresh() {
    var url = cartUrl() + '?view=ajax&_=' + Date.now();
    return fetch(url, { headers: { 'cache-control': 'no-cache' }, cache: 'no-store' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var tpl = tmp.querySelector('template[data-html="content"]');
        var opts = JSON.parse(tmp.querySelector('template[data-options]').innerHTML);
        if (!tpl) return;

        var scroller = document.querySelector(CONTENT + ' [data-e17-scroll]');
        var scrollTop = scroller ? scroller.scrollTop : 0;
        // Unter 460 px Höhe scrollt der ganze Drawer (.e17-cart) statt nur der Mitte – dann auch diese
        // Position merken. Ab 460 px ist sie immer 0 und es ändert sich nichts.
        var outer = visibleCart();
        var outerTop = outer ? outer.scrollTop : 0;
        var codeInput = document.querySelector(CONTENT + ' .e17-code__input');
        var codeValue = codeInput && flash && flash.type === 'error' ? codeInput.value : '';

        document.querySelectorAll(CONTENT).forEach(function (el) {
          el.innerHTML = tpl.innerHTML;
        });

        var newScroller = document.querySelector(CONTENT + ' [data-e17-scroll]');
        if (newScroller) newScroller.scrollTop = scrollTop;
        var newOuter = outerTop > 0 ? visibleCart() : null;
        if (newOuter) newOuter.scrollTop = outerTop;
        if (codeValue) {
          var newInput = document.querySelector(CONTENT + ' .e17-code__input');
          if (newInput) newInput.value = codeValue;
        }

        document.querySelectorAll('[data-bind="itemCount"]').forEach(function (el) {
          el.textContent = opts.item_count;
        });
        document.querySelectorAll('[data-ajax-cart-trigger]').forEach(function (el) {
          el.classList.toggle('has-cart-count', opts.item_count > 0);
        });
        if (window.PXUTheme && window.PXUTheme.currencyConverter) {
          window.PXUTheme.currencyConverter.convertCurrencies();
        }
        renderFlash();
        requestAnimationFrame(updateArrows);
        // Hinweis nur für genau diese Aktualisierung anzeigen; spätere (z. B. von der Produktseite
        // ausgelöste) Aktualisierungen sollen keinen veralteten Code-Hinweis mehr zeigen.
        flash = null;
        document.dispatchEvent(new CustomEvent('e17:cart:updated', { detail: opts }));
      });
  }

  function run(action) {
    if (busy) return Promise.resolve();
    setBusy(true);
    return action()
      .catch(function (err) {
        showFlash(err.message || 'Das hat leider nicht geklappt. Bitte versuche es erneut.', 'error');
      })
      .then(refresh)
      .catch(function () {})
      .then(function () { setBusy(false); });
  }

  function lineOf(el) {
    var line = el.closest('[data-e17-line]');
    return line ? parseInt(line.getAttribute('data-e17-line'), 10) : null;
  }

  function changeLine(line, quantity) {
    return postJSON('/cart/change.js', { line: line, quantity: Math.max(0, quantity) });
  }

  /** Aktuell wirksame (applicable) Rabattcodes aus dem Shopify-Warenkorb. */
  function appliedCodes(cart) {
    return (cart.discount_codes || [])
      .filter(function (d) { return d.applicable; })
      .map(function (d) { return d.code; });
  }

  function applyCode(code) {
    code = (code || '').trim();
    if (!code) {
      showFlash('Bitte gib einen Rabattcode ein.', 'error');
      return Promise.resolve();
    }
    flash = null;
    return getCart().then(function (before) {
      var existing = appliedCodes(before).filter(function (c) {
        return c.toLowerCase() !== code.toLowerCase();
      });
      return postJSON('/cart/update.js', { discount: existing.concat([code]).join(',') })
        .then(function () { return getCart(); })
        .then(function (after) {
          var hit = (after.discount_codes || []).filter(function (d) {
            return d.code.toLowerCase() === code.toLowerCase();
          })[0];
          if (hit && hit.applicable) {
            showFlash('Der Code „' + hit.code + '“ wurde angewendet.', 'success');
            return;
          }
          // Nicht anwendbaren Code wieder entfernen, damit der Warenkorb sauber bleibt.
          return postJSON('/cart/update.js', { discount: existing.join(',') }).then(function () {
            showFlash(
              'Der Code „' + code + '“ ist ungültig oder kann nicht mit deinen aktuellen Rabatten kombiniert werden.',
              'error'
            );
          });
        });
    });
  }

  function removeCode(code) {
    flash = null;
    return getCart().then(function (cart) {
      var rest = appliedCodes(cart).filter(function (c) {
        return c.toLowerCase() !== String(code).toLowerCase();
      });
      return postJSON('/cart/update.js', { discount: rest.join(',') });
    });
  }

  document.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('[data-e17-qty-change]');
    if (qtyBtn) {
      e.preventDefault();
      var line = lineOf(qtyBtn);
      var current = parseInt(qtyBtn.closest('.e17-qty').querySelector('.e17-qty__val').textContent, 10) || 0;
      var delta = parseInt(qtyBtn.getAttribute('data-e17-qty-change'), 10);
      flash = null;
      run(function () { return changeLine(line, current + delta); });
      return;
    }

    var removeBtn = e.target.closest('[data-e17-remove]');
    if (removeBtn) {
      e.preventDefault();
      flash = null;
      var removeLine = lineOf(removeBtn);
      run(function () { return changeLine(removeLine, 0); });
      return;
    }

    var addBtn = e.target.closest('[data-e17-add]');
    if (addBtn) {
      e.preventDefault();
      flash = null;
      var id = parseInt(addBtn.getAttribute('data-e17-add'), 10);
      run(function () { return postJSON('/cart/add.js', { items: [{ id: id, quantity: 1 }] }); });
      return;
    }

    var next = e.target.closest('[data-e17-scroll-next]');
    if (next) {
      e.preventDefault();
      var row = next.parentNode.querySelector('[data-e17-row]');
      if (row) row.scrollBy({ left: row.clientWidth * 0.8, behavior: 'smooth' });
      return;
    }

    var codeRemove = e.target.closest('[data-e17-code-remove]');
    if (codeRemove) {
      e.preventDefault();
      var chip = codeRemove.closest('.e17-code__chip');
      var code = chip ? chip.querySelector('span').textContent : '';
      run(function () { return removeCode(code); });
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-e17-code-form]');
    if (!form) return;
    e.preventDefault();
    var input = form.querySelector('input[name="discount"]');
    run(function () { return applyCode(input ? input.value : ''); });
  });

  // Esc schließt den Drawer; Hintergrund scrollt nicht mit, solange er offen ist.
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && window.PXUTheme && window.PXUTheme.jsAjaxCart) {
      window.PXUTheme.jsAjaxCart.hideDrawer();
    }
  });

  function watchDrawer() {
    var drawer = document.getElementById('theme-ajax-cart');
    if (!drawer || !window.MutationObserver) return;
    new MutationObserver(function () {
      var open = drawer.classList.contains('is-visible');
      document.documentElement.classList.toggle('e17-cart-open', open);
      if (open) setTimeout(updateArrows, 350);
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    document.addEventListener('scroll', function (e) {
      if (e.target && e.target.matches && e.target.matches('[data-e17-row]')) updateArrows();
    }, true);
    window.addEventListener('resize', updateArrows);
  }

  // Theme-Schnittstelle: updateView (Produktseite, Mengenfelder etc.) rendert den neuen Drawer.
  function hookTheme() {
    var api = window.PXUTheme && window.PXUTheme.jsAjaxCart;
    if (!api) return false;
    api.updateView = function () { return refresh(); };
    return true;
  }

  hookTheme();
  document.addEventListener('DOMContentLoaded', hookTheme);
  window.addEventListener('load', hookTheme);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchDrawer);
  } else {
    watchDrawer();
  }

  window.E17Cart = { refresh: refresh, applyCode: applyCode, hook: hookTheme };
})();
